var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 318,
    viewBox: "0 0 115 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0957031,
    width: 114.255,
    height: 317.905,
    fill: "url(#pattern0_503_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_503_167",
    patternContentUnits: "objectBoundingBox",
    width: 0.0840228,
    height: 0.0301977
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_503_167",
    transform: "scale(0.00262571 0.000943677)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_503_167",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAL5JREFUWEfF19sJwzAMheFqI9cTdZN4lS5ktJCgyJBA0lx8kY61wPejt0OvCRdjTMrmnBOhfcWJaFFXRN7QgAP+YeYvLOAM1y9AAq5wSMAd7h7whLsG1OBuAbW4S0ALbh7QipsG9OBmAb24ScAIPhwwig8FWODdAVZ4V4Al3hxgjTcFeODVAV54VYAn/hjgjd8GIPDLABR+GoDE/wLQ+C5gBr4FzMJLwEx8DViIKIlI2WrosVqmWQghMDOjcfV+pRz04dSS8eQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign2);
export default __webpack_public_path__ + "static/media/design-2.e17f94406eb01238ec8663fc05566b45.svg";
export { ForwardRef as ReactComponent };